import React, { useEffect, useState } from "react";
import { Modal, Form, Select, Button } from "antd";
import { useTranslation } from "react-i18next";
import { getUpgradeVersionList as getVersionListAPI } from "@/apis/instance";
import { WarningOutlined } from "@ant-design/icons";
import { notification } from "antd";

const { Option } = Select;

const warning =
  "Upgrading the AIOps Version cannot be reversed. If you want a previous version you will need to create a new instance.";

export const VersionUpgradeDialog = ({
  open,
  onClose,
  onUpgrade,
  version,
  platform,
  name,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [versions, setVersions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        setIsLoading(true);
        const response = await getVersionListAPI(version);
        if (response.status === "OK") {
          const v = response.value
            .filter(item => item["viaops_image_version"].startsWith(platform))
            .map((item) => item.sprint);
          setVersions(v);
        } else {
          setVersions([]);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        notification.error({
          description: t(
            "config.instance.error.version",
            "Fail to get version list from server.",
          ),
        });
      }
    };

    fetchVersions();
  }, [version]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onUpgrade(values);
      onClose();
    } catch (error) {
      console.error("validate form value failed:", error);
    }
  };

  return (
    <Modal
      open={open}
      title={t("instances.dialog.upgradeTitle", { name })}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          {t("instances.dialog.cancel", "Cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          {t("instances.dialog.upgrade", "Upgrade")}
        </Button>,
      ]}
    >
      {isLoading ? (
        <p>{t("instances.dialog.loading", "loading...")}</p>
      ) : (
        <>
          <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            {t("instances.dialog.currentVersion", "Current Version:")} {version}
          </div>
          <Form form={form} layout="vertical">
            <Form.Item
              name="version"
              label={t("instances.fields.aiopsVersion", "AIOps Version")}
              rules={[
                {
                  required: true,
                  message: t(
                    "instances.dialog.errors.requiredVersion",
                    "Version is required.",
                  ),
                },
              ]}
            >
              <Select
                allowClear
                placeholder={t(
                  "instances.dialog.placeholder.upgradeVersion",
                  "Select AIOps version for this instance.",
                )}
              >
                {versions.map((version) => (
                  <Option key={version} value={version}>
                    {version}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <div>
            <WarningOutlined style={{ color: "orange", marginRight: "8px" }} />
            <span>{t("instances.dialog.upgradeWarning", warning)}</span>
          </div>
        </>
      )}
    </Modal>
  );
};
